if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      let content = this.innerHTML;
      let titleFlag = false;
      let rightSideSplitWidth = 40; // initial value, increase this value if you want to increase the right side width in general
      content = content.replace(/<\/p>|<\/div>/g, '');
      content = content.split('<p>');
      for ( let i = 1; i < content.length; i++ ) {
        let contentArray = content[i].split(/<br>|<br\/>|\n/g);

        contentDOM += `<div class="table">`

        if ( (this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '') && this.dataset.titleLabelFromContent != 'true' ) {
          if ( !titleFlag ) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            if ( this.dataset.titleLabelLeft != '' ) {
              let titleLeftArray = this.dataset.titleLabelLeft.split(',');
              for ( let j = 0; j < titleLeftArray.length; j++ ) {
                contentDOM += `<span style=>${titleLeftArray[j]}</span>`;
              }
            }
            if ( this.dataset.titleLabelRight != '' ) {
              let titleRightArray = this.dataset.titleLabelRight.split(',');
              rightSideSplitWidth = rightSideSplitWidth / titleRightArray.length;
              for ( let j = 0; j < titleRightArray.length; j++ ) {
                contentDOM += `<span style="width: ${rightSideSplitWidth}%">${titleRightArray[j]}</span>`;
              }
            }
            contentDOM += `</span>`;
          }
        }

        if( this.dataset.titleLabelFromContent == 'true' && !titleFlag ) {
          let titleArray = contentArray[0].replace(',', '#SD*@N!SA');
          titleArray = titleArray.split('#SD*@N!SA');

          if(titleArray[1]?.length > 1) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            contentDOM += `<span>${titleArray[0]}</span>`;
            let titleArray2 = titleArray[1].split(',');
            rightSideSplitWidth = rightSideSplitWidth / (titleArray2.length);

            for ( let j = 0; j < titleArray2.length; j++ ) {
              contentDOM += `<span style="width: ${rightSideSplitWidth}%">${titleArray2[j]}</span>`;
            }

            contentDOM += `</span>`;
          }

        }

        for ( let j = 0; j < contentArray.length; j++ ) {
          if( this.dataset.titleLabelFromContent == 'true' && j == 0 ) {
            continue;
          }

          if (contentArray[j].length > 0 && contentArray[j].replace(/\s/g, '').length != 0 ) {
            let contentBlockArrayPrepare = contentArray[j].replace(',', '#SD*@N!SA')
            let contentBlockArray = contentBlockArrayPrepare.split('#SD*@N!SA');
            let isIndent = /^\s*-/.test(contentBlockArray[0]);
            contentDOM += `<span class="table-line ${isIndent ? 'table-line--indent' : ''}">`;
            for ( let k = 0; k < contentBlockArray.length; k++ ) {
              // split content by comma again
              let contentBlockArray2 = contentBlockArray[k].split(',');
              for ( let l = 0; l < contentBlockArray2.length; l++ ) {
                contentDOM += `<span style="width: ${rightSideSplitWidth}%">${contentBlockArray2[l]}</span>`;
              }
            }
            contentDOM += `</span>`;
          }
        }

        contentDOM += `</div>`;

      }
      
      this.innerHTML = contentDOM;

    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}
